/**
 * Appends the sb_ref parameter to a URL with the current window host.
 * If sb_ref already exists in the URL, it will not be duplicated.
 * Preserves all existing query parameters.
 *
 * @param url - The base URL to append the parameter to
 * @returns The URL with sb_ref parameter appended
 */
export function appendSbRef(url: string): string {
  try {
    const urlObject = new URL(url);

    // Check if sb_ref already exists
    if (!urlObject.searchParams.has('sb_ref')) {
      const host = window.location.host;
      urlObject.searchParams.append('sb_ref', host);
    }

    return urlObject.toString();
  } catch (error) {
    console.error('Failed to append sb_ref parameter:', error);
    return url;
  }
}
